/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgMiddleMember = (props: Props) => (
  <Icon viewBox="0 0 24 25" {...props}>
    <g fill="none">
      <path
        d="M4 1.4a3 3 0 0 0-1.659 5.5A2.997 2.997 0 0 0 1 9.4v1h2v-1a1 1 0 0 1 2 0v1h2v-1a2.997 2.997 0 0 0-1.341-2.5A3 3 0 0 0 4 1.4zm-1 3a1 1 0 1 1 2 0 1 1 0 0 1-2 0zm17 10a3 3 0 0 0-1.659 5.5A2.997 2.997 0 0 0 17 22.4v1h2v-1a1 1 0 1 1 2 0v1h2v-1a2.997 2.997 0 0 0-1.341-2.5A3 3 0 0 0 20 14.4zm-1 3a1 1 0 1 1 2 0 1 1 0 0 1-2 0zm-10-6a3 3 0 1 1 4.659 2.5A2.997 2.997 0 0 1 15 16.4v1H9v-1c0-1.044.533-1.963 1.341-2.5A2.997 2.997 0 0 1 9 11.4z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgMiddleMember as MiddleMember };
